export default {
  title: 'Dołącz do {{name}}!',
  default_program_name: 'Klub nagród',
  benefits: {
    earn_points: 'Zbieraj punkty przy każdym zamówieniu',
    get_deals: 'Otrzymuj ekskluzywne zniżki',
    redeem_points: 'Wymieniaj punkty na darmowe jedzenie',
  },
  terms: 'Rejestrując się, będziesz otrzymywać e-maile i SMS-y z ofertami od naszej&nbsp;',
  buttons: {
    log_in: 'Zaloguj się',
    sign_up: 'Zarejestruj się',
  },
  labels: {
    already_have_account: 'Masz już konto?',
  },
  signup_note:
    'Rejestrując się, będziesz otrzymywać e-maile i SMS-y z ofertami od naszej <0>restauracji</0> i <1>FoodAmigos</1>, naszego partnera technologicznego. Akceptujesz nasze <2>Warunki platformy</2> i <3>Politykę prywatności</3>.',
};
